



























import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import betslip from '@/betCalculation/betslip'
import { EventTypes } from '@altenar/models'
import config from '@/config'

enum PriceDirection {
  UP = 1,
  NONE = 0,
  DOWN = -1
}

const componentName: string = 'COddEventCard'
@Component({
  name: `${componentName}`,
  components: {}
})
export default class UiComponent extends Mixins() {
  @Prop({ default: {} }) public odd!: EventTypes.Odd
  public diff: number = PriceDirection.NONE
  public hideDiffTimeout: number = 0
  // public isSelected: boolean = false
  public get isSelected() {
    return betslip.selectedOddsIds.indexOf(this.odd.Id) > -1
  }
  public get priceUp() {
    return PriceDirection.UP
  }
  public get priceDown() {
    return PriceDirection.DOWN
  }
  public isArrowVisible(diff) {
    return (this.diff === diff && 1) || 0
  }
  public onClick() {
    betslip.toggleOdd(this.odd)
    // this.isSelected = !this.isSelected
    if (this.isSelected) {
      config.callbacks.oddclick(this.odd.Event.Id, this.odd.Id)
    }
  }
  public stopHideDiffTimeout() {
    if (this.hideDiffTimeout) {
      clearTimeout(this.hideDiffTimeout)
      this.hideDiffTimeout = 0
    }
  }
  public startHideDiffTimeout() {
    this.stopHideDiffTimeout()
    this.hideDiffTimeout = setTimeout(() => {
      this.diff = PriceDirection.NONE
    }, 10000)
  }
  public beforeDestroy() {
    this.stopHideDiffTimeout()
  }
  @Watch('odd', { immediate: false, deep: true })
  private priceWatch(newVal: EventTypes.Odd, oldVal: EventTypes.Odd): void {
    if (oldVal.Price > newVal.Price) {
      this.diff = PriceDirection.DOWN
    } else if (oldVal.Price < newVal.Price) {
      this.diff = PriceDirection.UP
    } else {
      this.diff = PriceDirection.NONE
    }
    this.startHideDiffTimeout()
  }
}
Vue.component(componentName, UiComponent)
